import domReady from '@wordpress/dom-ready';

domReady(() => {
  const FWP = window.FWP;
  console.log('Active');
  if (FWP) {
    document.addEventListener('facetwp-loaded', function () {
      const searchedKeyword = FWP.facets.global_search;
      const spanText = document.getElementById('fwp_search_word');
      const searchedWrapper = document.getElementById(
        'fwp_search_word_wrapper'
      );
      const resultCount = document.querySelector(
        '[data-name="resources_result_count"]'
      );
      const filtersActive = Object.values(FWP.facets).some(
        (facet) => facet.length > 0
      );

      resultCount.style.display = filtersActive ? 'block' : 'none';

      if (0 < FWP.settings.pager.total_rows) {
        if (spanText && searchedKeyword) {
          spanText.innerHTML = searchedKeyword;
        }
        if (searchedWrapper) {
          searchedWrapper.style.display = 'inline';
        }
      } else if (searchedWrapper) {
        searchedWrapper.style.display = 'none';
      }
    });
  }
});
